import './scss/christmas.scss';

class ChristmasLights {
    private container: HTMLElement;
    private index = 0;
    private steps = [1, 2, 3, 4];

    constructor(container: HTMLElement) {
        this.container = container;

        setTimeout(() => this.update(), 1000);
    }

    update() {
        this.index = this.index === this.lastIndex ? 0 : this.index + 1;

        const visibleLayers = [0, this.steps[this.index]];

        this.layers.forEach((layer, index) => {
            layer.setAttribute('data-hidden', visibleLayers.includes(index) ? 'false' : 'true');
        });

        setTimeout(() => this.update(), 1000);
    }

    get lastIndex() {
        return this.steps.length - 1;
    }

    get layers() {
        return Array.from(this.container.children);
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map((element) => {
            return new ChristmasLights(element);
        });
    }
}

ChristmasLights.createFromSelector('.js-christmas-lights');
